import React, { useState, useEffect } from 'react'
import { Row, Col, Input, Button, Alert } from 'reactstrap'
import { Checkbox } from "react-inputs-validation";
import NumberFormat from 'react-number-format';
const ValoresCobertura = ({ data, i, handleBack, handleClick, final, idCobertura, cliCodigoCore, mostrarRotura, volverResumen, estadoActualizar, setEstadoActualizar, hasSiguienteUbicacion }) => {

    const [datos2, setDatos] = useState(data);
    console.log('Data_is_inicia', datos2, data)
    const cambiarDatos = (value, j) => {


        if (typeof value == "boolean") {

            let data = [...datos2]
            data[j] = { ...datos2[j], value }
            setDatos(data)
            setEstadoActualizar(true)

        } else {

            console.log(datos2[j].value, value, datos2[j].valor)

            const value2 = parseFloat(datos2[j].value)
            const valor = parseFloat(datos2[j].valor)
            if (value >= 0 && value2 !== value && value <= valor) {
                let data = [...datos2]
                data[j] = { ...datos2[j], value }
                setDatos(data)
                setEstadoActualizar(true)
            }

        }

    }

    useEffect(() => {
        setDatos(data)
    }, [data])

    return (
        <div>
            {console.log('Data_is2', datos2, data, mostrarRotura)}
            {datos2.map(({ codigo, descripcion, valor, value, alerta }, j) =>
                <div key={'dataubicaciones' + i + '-' + j}>
                    {(mostrarRotura || !('roturaDeVidrios' === codigo)) &&

                        (typeof valor == "boolean" && i == 0) ?
                        <Row >
                            <Col xs={6} sm={4} > <p style={{}} >{descripcion} </p> </Col>

                            <Col xs={6} sm={5}>

                                {alerta &&
                                    <Alert color='warning'>
                                        {alerta}
                                    </Alert>
                                }
                            </Col>

                            <Col style={{
                                'display': 'flex',
                                alignItems: 'right',
                                justifyContent: 'right',
                                flex: 1,
                                height: '100%',
                            }} sm={3} >

                                <Checkbox
                                    className='float-right'
                                    id={codigo} // Optional.[String].Default: "".  Input ID.
                                    name={codigo} // Optional.[String].Default: "". Input name
                                    classNameInputBox={'check-uber-light'}
                                    value={value} // Required.[String].Default: "".
                                    onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                                    checked={value} // Required.[Bool].Default: false.
                                    // classNameInputBox={'check-uber'}
                                    onChange={(valueCheck, e) => {
                                        cambiarDatos(valueCheck, j)
                                    }} // Required.[Func].Default: () => {}. Will return the value.
                                />



                            </Col>
                        </Row> : null

                    }

                    {
                        (typeof valor != "boolean") &&
                        <Row >
                            <Col xs={6} sm={4} > <p style={{}} >{descripcion} </p> </Col>
                            <Col xs={6} sm={5}>


                                <NumberFormat
                                    className="form-control"
                                    disabled={false}
                                    value={value > valor ? 0 : value}
                                    thousandSeparator={','}
                                    decimalSeparator={'.'}
                                    style={{ width: 'inherit', fontSize: 20, textAlign: 'right', }}
                                    decimalScale={2}
                                    prefix={''}
                                    onValueChange={(valor, e) => {

                                        console.log('Valor', valor)
                                        cambiarDatos(valor.floatValue, j)


                                    }}

                                />
                            </Col>
                            <Col sm={3}>
                                <p style={{ textAlign: 'right', color: '#909090', }}>{valor.toLocaleString(navigator.language, { minimumFractionDigits: 0 })}</p>
                            </Col>
                        </Row>
                    }
                </div>
            )}


            <div className='flex' style={{ margin: 10, marginTop: 100 }}  >
                <Button className="btn btn-detail-gray" onClick={() => handleBack()} style={{ margin: "auto" }} disabled={volverResumen} >
                    <i className="fa fa-chevron-circle-left" aria-hidden="true" />{"  REGRESAR"}
                </Button>
                <Button disabled={estadoActualizar ? false : !hasSiguienteUbicacion} className={estadoActualizar ? 'btn btn-purple fe-pulse' : 'btn btn-primary'} onClick={() => { handleClick(datos2, i) }} style={{ margin: "auto", }} >
                    <i className="fa fa-chevron-circle-right " aria-hidden="true" />{estadoActualizar ? ' ACTUALIZAR VALORES' : ' SIGUIENTE'}
                </Button>
            </div>
        </div>
    )
}

export default ValoresCobertura